function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, PRODUCTS, COLLECTIONS, ISSUES, EVENTS, DISPATCH, CAUSES_PCT */
/* global Button, Pill, Eyebrow, Icon, SectionHead, Marquee, HoverImage */
// ============================================================================
// Home sections — Hero, Manifesto strip, Featured collections, Product grids,
// Issues, Calendar, Cause split, Dispatch, Testimonials, Newsletter.
// ============================================================================
var _React = React,
  useStateH = _React.useState,
  useRefH = _React.useRef,
  useMemoH = _React.useMemo,
  useEffectH = _React.useEffect;

// ============================================================================
// HERO — editorial. Big italic serif statement, single rust accent,
// product preview on right.
// ============================================================================
function Hero(_ref) {
  var onShop = _ref.onShop,
    onPdp = _ref.onPdp;
  var featured = PRODUCTS[11]; // Good Trouble women's
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--bone)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      paddingTop: 56,
      paddingBottom: 96
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.05fr 0.9fr",
      gap: 80,
      alignItems: "center"
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust"
  }, "Drop 04 \u2014 Summer \u201926"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "clamp(48px, 8vw, 132px)",
      lineHeight: 0.96,
      letterSpacing: "-0.02em",
      margin: "32px 0 0",
      color: "var(--ink)",
      textWrap: "balance"
    }
  }, "Wear what", /*#__PURE__*/React.createElement("br", null), "you ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic",
      color: "var(--rust)"
    }
  }, "believe.")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 32,
      maxWidth: 480,
      fontSize: 18,
      lineHeight: 1.6,
      color: "var(--muted)"
    }
  }, "Activist apparel for people who give a damn. Print-on-demand, artist-designed, and ten percent of every order funds the organizations doing the hard work."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: 14,
      marginTop: 40
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: onShop
  }, "Shop the drop ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 16
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    size: "lg",
    onClick: function onClick() {
      var _document$getElementB;
      return (_document$getElementB = document.getElementById("manifesto")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, "Read the manifesto")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 64,
      paddingTop: 32,
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: "clamp(18px, 2vw, 26px)",
      lineHeight: 1.5,
      color: "var(--ink)",
      maxWidth: 620
    }
  }, "Wear what you believe. ", /*#__PURE__*/React.createElement("em", {
    style: {color: "var(--rust)", fontStyle: "italic"}
  }, "10% of every order"), " funds grassroots organizing."))), /*#__PURE__*/React.createElement(FeaturedHeroCard, {
    p: featured,
    onPdp: onPdp
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      paddingBottom: 32
    }
  }, /*#__PURE__*/React.createElement(Marquee, {
    items: ["DROP 04 LIVE NOW", "Printed in Los Angeles", "10% to grassroots orgs", "New designs every Friday", "Worldwide delivery"]
  })));
}
function FeaturedHeroCard(_ref2) {
  var p = _ref2.p,
    onPdp = _ref2.onPdp;
  var _useStateH = useStateH(false),
    _useStateH2 = _slicedToArray(_useStateH, 2),
    hover = _useStateH2[0],
    setHover = _useStateH2[1];
  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 20,
      left: 20,
      zIndex: 2,
      display: "flex",
      flexDirection: "column",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    tone: "ink"
  }, "Featured \xB7 Issue 04")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 20,
      right: 20,
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-mono)",
      fontSize: 11,
      color: hover ? "var(--bone)" : "var(--ink)",
      background: hover ? "var(--ink)" : "var(--bone)",
      padding: "4px 8px",
      transition: "background 240ms, color 240ms",
      border: "1px solid " + (hover ? "var(--ink)" : "var(--line-2)")
    }
  }, "SKU \xB7 RR-", p.id.toUpperCase().slice(0, 6))), /*#__PURE__*/React.createElement(HoverImage, {
    src: p.img,
    src2: p.imgAlt,
    hover: hover,
    ratio: "0.86 / 1",
    alt: p.name,
    onClick: function onClick() {
      return onPdp(p);
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr auto",
      gap: 20,
      paddingTop: 20,
      alignItems: "flex-end"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, null, "New \xB7 ", p.cause), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8,
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: 28,
      lineHeight: 1.1,
      color: "var(--ink)"
    }
  }, p.name, "."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 6,
      fontSize: 13,
      color: "var(--muted)"
    }
  }, "From ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--ink)"
    }
  }, "$", p.price.toFixed(0)), " \xB7 ", p.sizes.length, " sizes \xB7 ", p.colors.length, " colours")), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "md",
    onClick: function onClick() {
      return onPdp(p);
    }
  }, "View piece ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 14
  }))));
}

// ============================================================================
// VALUE STRIP — quiet, four columns, hairline dividers
// ============================================================================
function ValueStrip() {
  var ITEMS = [{
    ic: "leaf",
    t: "Print-on-demand",
    s: "Zero excess. Made when ordered."
  }, {
    ic: "sparkle",
    t: "Artist-designed",
    s: "Independent artists, fair royalties."
  }, {
    ic: "package",
    t: "Printed in LA",
    s: "Ships worldwide in 3–7 days."
  }, {
    ic: "heart",
    t: "10% to causes",
    s: "Funds grassroots orgs every quarter."
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--bone)",
      borderTop: "1px solid var(--line)",
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      padding: "40px 0"
    },
    className: "responsive-4col"
  }, ITEMS.map(function (it, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        padding: "0 32px",
        borderLeft: i > 0 ? "1px solid var(--line)" : "none",
        display: "flex",
        flexDirection: "column",
        gap: 10
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: it.ic,
      size: 22,
      color: "var(--rust)"
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: "var(--font-serif)",
        fontSize: 22,
        color: "var(--ink)",
        lineHeight: 1.15
      }
    }, it.t), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 13,
        color: "var(--muted)",
        lineHeight: 1.5
      }
    }, it.s));
  }))));
}

// ============================================================================
// FEATURED COLLECTIONS — magazine 3-up, asymmetric heights, hairline rules
// ============================================================================
function FeaturedCollections(_ref3) {
  var onCollection = _ref3.onCollection;
  var PICKS = COLLECTIONS.slice(0, 3);
  return /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Shop the movement",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Pick your ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "battle.")),
    lede: "Six edits, each tied to a cause we fund. Browse the full archive or follow a single thread.",
    action: /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      onClick: function onClick() {
        return onCollection("best-sellers");
      }
    }, "View all collections ", /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 14
    }))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.2fr 0.9fr 0.9fr",
      gap: 32,
      alignItems: "stretch"
    },
    className: "responsive-3col"
  }, PICKS.map(function (c, i) {
    return /*#__PURE__*/React.createElement(CollectionCard, {
      key: c.id,
      c: c,
      idx: i,
      tall: i === 0,
      onClick: function onClick() {
        return onCollection(c.id);
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24,
      paddingTop: 24,
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 24
    },
    className: "responsive-3col"
  }, COLLECTIONS.slice(3).map(function (c) {
    return /*#__PURE__*/React.createElement("a", {
      key: c.id,
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        onCollection(c.id);
      },
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 0",
        borderTop: "1px solid var(--line)",
        color: "var(--ink)"
      },
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.paddingLeft = "12px";
        e.currentTarget.style.color = "var(--rust)";
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.paddingLeft = "0px";
        e.currentTarget.style.color = "var(--ink)";
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "var(--font-serif)",
        fontSize: 22
      }
    }, c.name), /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-flex",
        gap: 14,
        alignItems: "center",
        fontSize: 13,
        color: "var(--muted)"
      }
    }, c.count, " pieces ", /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 14
    })));
  })))));
}
function CollectionCard(_ref4) {
  var c = _ref4.c,
    idx = _ref4.idx,
    tall = _ref4.tall,
    onClick = _ref4.onClick;
  var _useStateH3 = useStateH(false),
    _useStateH4 = _slicedToArray(_useStateH3, 2),
    hover = _useStateH4[0],
    setHover = _useStateH4[1];
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      background: "transparent",
      border: "none",
      padding: 0,
      cursor: "pointer",
      textAlign: "left",
      color: "var(--ink)",
      display: "flex",
      flexDirection: "column",
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(HoverImage, {
    src: c.img,
    alt: c.name,
    hover: hover,
    ratio: tall ? "0.92 / 1.2" : "0.92 / 1"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: hover ? "rgba(20,20,20,0.18)" : "rgba(20,20,20,0.0)",
      transition: "background 280ms"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 16,
      top: 16
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    tone: "bone"
  }, String(idx + 1).padStart(2, "0"), " / 06"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr auto",
      alignItems: "baseline",
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: "var(--font-serif)",
      fontSize: 36,
      lineHeight: 1.05,
      fontStyle: hover ? "italic" : "normal",
      letterSpacing: "-0.01em",
      transition: "font-style 200ms"
    }
  }, c.name), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.04em",
      color: hover ? "var(--rust)" : "var(--muted)",
      transition: "color 160ms"
    }
  }, c.count, " pieces ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowDR",
    size: 14
  }))));
}

// ============================================================================
// PRODUCT CARD — clean. White surface inside the cream page.
// ============================================================================
function ProductCard(_ref5) {
  var p = _ref5.p,
    onCard = _ref5.onCard,
    onAdd = _ref5.onAdd;
  var _useStateH5 = useStateH(false),
    _useStateH6 = _slicedToArray(_useStateH5, 2),
    hover = _useStateH6[0],
    setHover = _useStateH6[1];
  var _useStateH7 = useStateH(false),
    _useStateH8 = _slicedToArray(_useStateH7, 2),
    added = _useStateH8[0],
    setAdded = _useStateH8[1];
  var quickAdd = function quickAdd(e) {
    e.stopPropagation();
    setAdded(true);
    onAdd === null || onAdd === void 0 || onAdd(p);
    setTimeout(function () {
      return setAdded(false);
    }, 1600);
  };
  return /*#__PURE__*/React.createElement("article", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: function onClick() {
      return onCard === null || onCard === void 0 ? void 0 : onCard(p);
    },
    style: {
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
      transition: "transform 200ms var(--ease)",
      transform: hover ? "translateY(-3px)" : "translateY(0)"
    }
  }, /*#__PURE__*/React.createElement(HoverImage, {
    src: p.img,
    src2: p.imgAlt,
    hover: hover,
    ratio: "0.86 / 1",
    alt: p.name
  }, p.badge && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 14,
      left: 14
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    tone: p.badge === "NEW" ? "rust" : "ink"
  }, p.badge)), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      bottom: 14,
      left: 14,
      right: 14,
      display: "flex",
      gap: 8,
      transform: hover ? "translateY(0)" : "translateY(8px)",
      opacity: hover ? 1 : 0,
      transition: "transform 240ms var(--ease-out), opacity 240ms"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: quickAdd,
    style: {
      flex: 1,
      background: added ? "var(--forest)" : "var(--bone)",
      color: added ? "var(--bone)" : "var(--ink)",
      border: "1px solid " + (added ? "var(--forest)" : "var(--ink)"),
      padding: "12px 14px",
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "0.04em",
      display: "inline-flex",
      justifyContent: "center",
      gap: 8,
      alignItems: "center",
      transition: "all 180ms"
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!added) {
        e.currentTarget.style.background = "var(--ink)";
        e.currentTarget.style.color = "var(--bone)";
      }
    },
    onMouseLeave: function onMouseLeave(e) {
      if (!added) {
        e.currentTarget.style.background = "var(--bone)";
        e.currentTarget.style.color = "var(--ink)";
      }
    }
  }, added ? /*#__PURE__*/React.createElement(React.Fragment, null, "Added ", /*#__PURE__*/React.createElement(Icon, {
    name: "heart",
    size: 12
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, "Quick add ", /*#__PURE__*/React.createElement(Icon, {
    name: "plus",
    size: 12
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 16,
      display: "grid",
      gridTemplateColumns: "1fr auto",
      alignItems: "baseline",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 11,
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      color: "var(--muted)"
    }
  }, p.cause, " \xB7 ", p.type), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 6,
      fontFamily: "var(--font-serif)",
      fontStyle: hover ? "italic" : "normal",
      fontSize: 20,
      lineHeight: 1.15,
      color: "var(--ink)",
      transition: "font-style 180ms",
      textWrap: "pretty"
    }
  }, p.name)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 22,
      color: "var(--ink)",
      whiteSpace: "nowrap"
    }
  }, "$", p.price.toFixed(0))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 6
    }
  }, p.colors.slice(0, 4).map(function (c, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      style: {
        width: 10,
        height: 10,
        borderRadius: 999,
        background: swatch(c),
        border: "1px solid var(--line-2)"
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 11,
      letterSpacing: "0.08em",
      color: "var(--faint)",
      textTransform: "uppercase"
    }
  }, p.sizes[0], "\u2013", p.sizes[p.sizes.length - 1])));
}
function swatch(c) {
  var lc = c.toLowerCase();
  if (lc.includes("white")) return "#FAFAF7";
  if (lc.includes("forest")) return "#2A3A2E";
  if (lc.includes("grey") || lc.includes("heather")) return "#A8A39B";
  return "#1A1A1A";
}

// ============================================================================
// PRODUCT ROW
// ============================================================================
function ProductRow(_ref6) {
  var products = _ref6.products,
    eyebrow = _ref6.eyebrow,
    title = _ref6.title,
    lede = _ref6.lede,
    onCard = _ref6.onCard,
    onAdd = _ref6.onAdd,
    onMore = _ref6.onMore,
    id = _ref6.id;
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: eyebrow,
    title: title,
    lede: lede,
    action: onMore && /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      onClick: onMore
    }, "See all ", /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 14
    }))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: 32
    },
    className: "responsive-4col"
  }, products.map(function (p) {
    return /*#__PURE__*/React.createElement(ProductCard, {
      key: p.id,
      p: p,
      onCard: onCard,
      onAdd: onAdd
    });
  }))));
}
Object.assign(window, {
  Hero: Hero,
  ValueStrip: ValueStrip,
  FeaturedCollections: FeaturedCollections,
  ProductCard: ProductCard,
  ProductRow: ProductRow,
  swatch: swatch
});
